import { useLoaderData } from "@remix-run/react";
import { loader } from "./route";
import { localeAttr } from "~/utils/helper";
import { BlogTags, DateAndAuthor } from "~/components/blog/BlogBox";
import useHost from "~/utils/hooks/useHost";
import useLocalStorage from "~/utils/hooks/useLocalStorage";
import { EMAIL_SUBSCRIBED_STORAGE } from "~/utils/constants";
import { useTranslation } from "react-i18next";
import SubscribeEmailPopup from "~/components/blog/SubscribeEmailPopup";
import { BlocksRenderer } from "@strapi/blocks-react-renderer";
import parse from "html-react-parser";

export default function Report() {
  const { t } = useTranslation("blog");
  const { blog, locale, toast } = useLoaderData<typeof loader>();

  const HOST = useHost();

  const [subscribed, setSubscribed] = useLocalStorage(
    EMAIL_SUBSCRIBED_STORAGE,
    false,
  );

  return (
    <div>
      <p className={`text-2xl text-Secondary-Dark-Blue-db-500`}>
        {localeAttr(blog.attributes, "title", locale)}
      </p>
      <DateAndAuthor blog={blog} locale={locale} />
      <BlogTags blog={blog} locale={locale} className="mt-5" />
      <p className={`relative mt-3 `}>
        <div
          className={
            "mt-3 text-sm text-Secondary-Crayola-Space-Cs-600 [&_*]:[all:revert]  [&_img]:max-w-full [&_img]:object-cover "
          }
        >
          {parse(localeAttr(blog.attributes, "content", locale) ?? "")}
          {/* <BlocksRenderer
            content={localeAttr(blog.attributes, "details", locale)}
          /> */}
        </div>
        {!subscribed && toast?.type !== "success" && (
          <div className={`-mt-[min(50%,400px)] h-1/2  w-full overflow-hidden`}>
            <div className="left-0 top-0 flex h-full w-full items-center justify-center py-6 backdrop-blur-lg [-webkit-backdrop-filter:blur(16px)]">
              <SubscribeEmailPopup
                title="enterEmailReport"
                button="viewReport"
              />
            </div>
          </div>
        )}
      </p>
    </div>
  );
}
